import HeaderPage from '../../Components/Header/Header'
import { Border, MainBody } from '../Main/Main-Styled'
import frotaAdvisorEx from '../../images/frotaAdvisorEx.png'
import lupa from '../../images/lupa.png'
import lampada from '../../images/lampada.png'
import coneccao from '../../images/coneccao.png'
import checkCircle from '../../images/checkCircle.png'
import personaMotorista from '../../images/personaMotorista.png'
import listaMotorista from '../../images/listaMotorista.png'
import personaGestor from '../../images/personaGestor.png'
import listaGestor from '../../images/listaGestor.png'
import personaPrestador from '../../images/personaPrestador.png'
import listaPrestador from '../../images/listaPrestador.png'
import userFlows from '../../images/userFlows.png'
import frotaExemplos from '../../images/frotaExemplos.png'
import MotoristaMobile from '../../images/motoristaPersonaExMobile.png'
import GestorMobile from '../../images/GestorPersonaExMobile.png'
import PrestadorMobile from '../../images/PrestadorPersonaExMobile.png'
import {
  ContainerDesc,
  ContainerStyled,
  ContainerStyledImgs
} from './Projeto4-Styled'
import FooterPage from '../../Components/Footer/Footer'
function Projeto4() {
  return (
    <>
      <HeaderPage />

      <MainBody>
        <ContainerStyled>
          <div>
            <h1>Frota Advisor</h1>
            <h2>Resumo</h2>

            <p>
              Aplicativo que conecta motoristas, transportadoras e prestadores
              de serviço para facilitar a oferta e contratação de serviços.
            </p>
            <div>
              <span>
                Empresa: <p>TGID (Transform and grow in digital)</p>
              </span>
              <span>
                Participantes:
                <p>
                  Lygia Magalhães (UX/UI Designer) e Daniel Rezende (Lead
                  Product Designer)
                </p>
              </span>
            </div>
            <div className="mobileEx">
              <img src={frotaAdvisorEx} alt="" />
            </div>
          </div>

          <div className="desktopEx">
            <img src={frotaAdvisorEx} alt="" />
          </div>
        </ContainerStyled>
        <ContainerDesc>
          <div className="processo">
            <h2 className="sectName">Processo</h2>

            <ul>
              <li>
                <div className="process">
                  <img src={lupa} alt="icone de lupa" />
                  <p>
                    Identificar e entender o problema por meio de pesquisas e
                    observações.
                  </p>
                </div>
              </li>

              <li>
                <div className="process">
                  <img src={lampada} alt="icone de lampada" />
                  <p>
                    Analisar as informações coletadas para definir o problema
                    principal a ser resolvido.
                  </p>
                </div>
              </li>

              <li>
                <div className="process">
                  <img src={coneccao} alt="icone de coneccao" />
                  <p>Prototipar uma solução digital.</p>
                </div>
              </li>

              <li>
                <div className="process">
                  <img src={checkCircle} alt="icone de checkCircle" />
                  <p>
                    Verificar se a solução atende às necessidades do
                    público-alvo.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </ContainerDesc>

        <ContainerDesc>
          <h2>O problema</h2>

          <p>
            Caminhoneiros e transportadoras enfrentam dificuldades para
            encontrar prestadores de serviços confiáveis em caso de pane,
            especialmente em viagens. A falta de informações sobre a qualidade
            do serviço e especialidades dos mecânicos gera insegurança e pode
            levar a reparos inadequados ou preços abusivos.
          </p>
        </ContainerDesc>
        <ContainerDesc>
          <h2>Entrevistas com os usuários</h2>

          <p>
            Foram conduzidas entrevistas com dois perfis principais:
            caminhoneiros e transportadoras, com o objetivo de entender como
            lidam com problemas mecânicos durante viagens e processos de
            manutenção.
          </p>
          <p>
            Os relatos indicam que a maior parte das falhas ocorre de forma
            inesperada, frequentemente em trechos críticos como subidas,
            impactando diretamente o prazo das entregas. Alguns motoristas
            possuem conhecimento básico de manutenção e carregam peças de
            reposição, mas, na maioria dos casos, é necessário buscar suporte
            externo. A comunicação com transportadoras costuma acontecer via
            WhatsApp, sem padronização ou rastreabilidade.
          </p>
          <p>
            Foram identificados desafios críticos, como:
            <ul>
              <li>Dificuldade em encontrar mecânicos confiáveis rapidamente</li>
              <li>Falta de previsibilidade de custos e tempo de reparo</li>
              <li>Riscos de segurança (ex: carga exposta durante a parada)</li>
              <li>Tempo elevado de manutenção em casos mais complexos</li>
            </ul>
          </p>
        </ContainerDesc>
        <ContainerDesc>
          <h2>Persona</h2>
          <ContainerStyledImgs>
            <div>
              <p>Motorista</p>
              <div>
                <img src={personaMotorista} alt="" />
              </div>
            </div>

            <div>
              <img className="desktopSocio" src={listaMotorista} alt="" />
              <img className="mobileSocio" src={MotoristaMobile} alt="" />
            </div>
          </ContainerStyledImgs>
          <ContainerStyledImgs>
            <div>
              <p>Gestor de frota</p>
              <div>
                <img src={personaGestor} alt="" />
              </div>
            </div>

            <div>
              <img className="desktopSocio" src={listaGestor} alt="" />
              <img className="mobileSocio" src={GestorMobile} alt="" />
            </div>
          </ContainerStyledImgs>
          <ContainerStyledImgs>
            <div>
              <p>Prestadores de serviços</p>
              <div>
                <img src={personaPrestador} alt="" />
              </div>
            </div>

            <div>
              <img className="desktopSocio" src={listaPrestador} alt="" />
              <img className="mobileSocio" src={PrestadorMobile} alt="" />
            </div>
          </ContainerStyledImgs>
        </ContainerDesc>
        <ContainerDesc className="userFlows">
          <h2>User flows</h2>

          <img style={{ maxWidth: '100%' }} src={userFlows} alt="userFlows" />
        </ContainerDesc>

        <ContainerDesc>
          <div className="processo validacao">
            <h2 className="sectName">A proposta</h2>
            <p>
              Atualmente, o produto foi lançado e segue em evolução contínua.
            </p>
            <p>
              O uso em contexto real trouxe aprendizados importantes. Um dos
              principais foi a necessidade de adaptar o nível de complexidade da
              interface ao perfil dos usuários. O processo inicial de login, por
              exemplo, se mostrou uma barreira significativa para motoristas com
              menor familiaridade digital, exigindo uma reformulação para uma
              abordagem mais simples, direta e acessível.
            </p>
            <p>
              Esse processo iterativo tem sido guiado por dados de uso e
              feedback contínuo dos usuários, permitindo ajustes incrementais e
              decisões mais fundamentadas. O produto se consolidou como uma
              plataforma em construção, que evolui a partir da complexidade real
              do ecossistema em que está inserido.
            </p>

            <div>
              <a
                className="LinkExterno"
                target="_blank"
                rel="noopener noreferrer"
                href="https://apps.apple.com/br/app/frota-advisor/id6752273298"
              >
                Link para a Frota Advisor.
              </a>

              <img style={{ maxWidth: '100%' }} src={frotaExemplos} alt="" />
            </div>
          </div>
        </ContainerDesc>
      </MainBody>
      <Border style={{ marginTop: '64px' }} />
      <FooterPage />
    </>
  )
}

export default Projeto4
